import { Ban, X } from 'lucide-react'
import { Button } from '../../ui/button'

// Appears above the table once anything is ticked. Selection survives paging
// and filter changes deliberately: the common case is "search for the last
// name, tick everyone, search again" before suppressing in one go.
export default function ContactsSelectionBar({ count, onSuppress, onClear }) {
  if (count === 0) return null
  return (
    <div
      role="region"
      aria-label="Selected contacts"
      className="flex flex-wrap items-center gap-3 rounded-md border border-primary/40 bg-primary/5 px-3 py-2 text-sm"
    >
      <span className="font-medium">{count.toLocaleString()} selected</span>
      <Button
        variant="outline"
        size="sm"
        onClick={onSuppress}
        className="text-[var(--orange-11)] hover:text-[var(--orange-11)]"
      >
        <Ban className="mr-1.5 h-3.5 w-3.5" />
        Suppress selected
      </Button>
      <Button variant="ghost" size="sm" onClick={onClear} className="ml-auto">
        <X className="mr-1 h-3.5 w-3.5" />
        Clear selection
      </Button>
    </div>
  )
}
